import React from 'react'
// components
import DynamicIcon from 'components/UI/Icons/DynamicIcon'
// types
import { IFilter } from 'types/graphql'
// utils
import { get } from 'lodash'

export const getSidebarConfig = (filters: IFilter[] = [], page: string) =>
  filters.map(({ name, slug, meta }) => {
    const icons = get(meta, 'icons', {})

    return {
      name,
      path: [page],
      icon: <DynamicIcon active={icons.active} inactive={icons.inactive} hovered={icons.hovered} />,
      getLink: () => `/${page}/${slug}`,
      determineIsActive: (querySlug: string) => querySlug === slug
    }
  })
